module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/inspiration-elite.d457654a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/inspiration-elite.png
// module id = 3741
// module chunks = 11